<template>
  <Container :class="$style.container">
    <div>
      <ButtonBack
        text="Devices"
        :to="devicesRoute"
      />
    </div>
    <Container :class="$style.gridContainer">
      <HeadingMedium
        hasMargin
        weight="bold"
      >
        Manage Settings
      </HeadingMedium>
      <ParagraphBody>
        Manage device management settings
      </ParagraphBody>
      <CardSettings
        :showTitle="false"
        title=""
      >
        <div :class="$style.switchBox">
          <ToggleSwitch
            :class="$style.switch"
            data-test-id="deviceListDefault"
            :value="isDevicesListDefault"
            @input="(value) => handleToggleChange('deviceListHomePage', value)"
          />
          <HeadingSmall>
            Set Devices List as Default Page {{ getDevicesListDefaultLabel }}
          </HeadingSmall>
        </div>
        <ParagraphBody>
          Enabling this option allows you to set the Device List as the default page when
          navigating to Devices. Disabling this option sets the Device Overview
          as the default page.
        </ParagraphBody>
      </CardSettings>
    </Container>
  </Container>
</template>

<script>
import
{
  ButtonBack,
  Container,
  HeadingMedium,
  HeadingSmall,
  ParagraphBody,
  ToggleSwitch,
}
  from '@jumpcloud/ui-components';
import {
  ItemTypeConsts,
  ItemTypeRoutes,
} from 'client/util/Constants';
import CardSettings from 'client/components/CardSettings.vue';
import LocalStorageConsts from 'client/util/Constants/LocalStorageConstants';
import LocalStorageService from 'client/util/LocalStorageService';

export default {
  name: 'DevicesSettingsMainPanel',

  LocalStorageService,

  components: {
    ButtonBack,
    Container,
    CardSettings,
    HeadingMedium,
    HeadingSmall,
    ParagraphBody,
    ToggleSwitch,
  },

  data() {
    return {
      devicesRoute: `/${ItemTypeRoutes[ItemTypeConsts.device]}`,
      devicesLocalStorageSettings: JSON.parse(this.$options.LocalStorageService.getValue(
        LocalStorageConsts.devicesMainPanelLandingTab,
      )) || {},
    };
  },

  computed: {
    getDevicesListDefaultLabel() {
      return this.isDevicesListDefault ? 'On' : 'Off';
    },
    isDevicesListDefault() {
      return this.devicesLocalStorageSettings
        ? this.devicesLocalStorageSettings.deviceListHomePage
        : false;
    },
  },

  methods: {
    // On future when we have to add more options,
    // the same localStorage variable will be used and
    // this new option will only be added to the object.
    handleToggleChange(key, value) {
      this.devicesLocalStorageSettings[key] = value;

      this.saveDevicesSettings();
    },

    saveDevicesSettings() {
      this.$options.LocalStorageService.setItem(
        LocalStorageConsts.devicesMainPanelLandingTab,
        JSON.stringify(this.devicesLocalStorageSettings),
      );
    },
  },
};
</script>
<style module scoped>
.container {
  background-color: var(--jc-color-disabled);
  height: 100%;
}

.gridContainer {
  background-color: var(--jc-color-surface-light);
  margin-top: 15px;
  max-width: 57rem;
}

.switchBox {
  align-items: flex-end;
  display: flex;
  padding-bottom: 15px;
}

.switch {
  padding-right: var(--jc-spacer);

  --switch-label-weight: 400;
}
</style>
